export default "__VITE_ASSET__tniZO_kq__"